import Vue, { VueConstructor } from 'vue';
import { gameStore } from '@/store/game/store';
import { JustoneClient } from '@/client';
import { Action } from '@/actions';
import Keypress from "vue-keypress";
import _ from 'lodash';
import { ElInput } from 'element-ui/types/input';


export default (Vue as VueConstructor<Vue & {
    $refs: {
        hintInput: any[]
    };
}>).extend({
    data() {
        return {
            hint: "",
            hintSent: false
        }
    },
    computed: {
        hintValid(): boolean {
            //return !!this.hint && this.hint.toLowerCase() == this.hintCheck?.toLowerCase();
            return !!this.hint;
        },
        turn() {
            return gameStore.state.currentTurn.turn;
        },
        showHints(): boolean {
            return gameStore.state.players.length - 1 == gameStore.state.currentTurn.playersWhoAddedHints.length;
        },
        playersHints() {
            const ph = _.map(_.reject(gameStore.state.players, p => p.id == gameStore.state.currentTurn.currentPlayerId), p => {
                return {
                    id: p.id,
                    name: p.name,
                    hintSent: _.includes(gameStore.state.currentTurn.playersWhoAddedHints, p.id),
                    hint: gameStore.state.currentTurn.hints[p.id],
                    isThisPlayer: p.id == gameStore.state.playerInfo.id
                }
            });
            return ph;
        }
    },
    methods: {
        sendHint() {
            if (!this.hintValid) return;
            JustoneClient.getInstance().send({
                action: Action.hintAdded,
                hint: this.hint
            });
            this.hintSent = true;
        }
    },
    watch: {
        turn() {
            this.hintSent = false;
            this.hint = "";
            this.$nextTick(() => {
                const h = this.$refs.hintInput ? [...this.$refs.hintInput].pop() : undefined;
                if (h) h.focus();
            })
        }
    },
    mounted(){
        this.$nextTick(() => {
            const h = [...this.$refs.hintInput].pop();
            if (h) h.focus();
        })
    },
    components: {
        Keypress
    }
});